const t = "_wrapper_1trq0_1", o = "_disableBoxShadow_1trq0_14", e = "_title_1trq0_26", n = "_icon_1trq0_27", _ = "_menuButton_1trq0_31", r = {
  wrapper: t,
  disableBoxShadow: o,
  title: e,
  icon: n,
  menuButton: _
};
export {
  r as default,
  o as disableBoxShadow,
  n as icon,
  _ as menuButton,
  e as title,
  t as wrapper
};
